export default "__VITE_ASSET__9a603487__"